<!-- <div class="text-end Reasons-div">
  <i class="Nav-Link fw-bold text-primary fs-7 underline cursor-pointer" (click)="ReasonListModalPopup()">Reasons List</i>
</div> -->
 <div class="report-container">
      <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-2">
          <div id="kt_app_toolbar_container" class="app-container container-xxl d-flex flex-stack toolbar_container">
            <div class="page-title me-3">
              <div class="page-heading text-dark fw-bold fs-3 my-0">Overall Report</div>
              <div class="gap-2 gap-lg-3 filter-container">
              <!-- For Switching Client -->
                <div *ngIf="switchUserAccess" class="d-flex">
                  <select class="form-select filter-search-By me-3" name="searchBy" [(ngModel)]="searchBy" (change)="searchByChange()">
                    <option value="" selected>Search By</option>
                    <ng-container *ngFor="let Item of SearchByContainer">
                      <option [value]="Item==='survey_id' ? 'survey':Item">{{Item | titlecase}}</option>
                    </ng-container>
                  </select>
                  <div *ngIf="ShowSearchBar" class="position-relative search-container">
                    <span
                      [inlineSVG]="'../../../media/icons/duotune/general/gen021.svg'"
                      class="
                        svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500
                        position-absolute
                        top-50
                        ms-1
                        translate-middle-y">
                      <svg style="margin-top:10px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                        </svg>
                    </span>
                    <input
                      type="text"
                      class="form-control search-input"
                      name="search"
                      [placeholder]="placeholderShow()"
                      [(ngModel)]="searchText"
                      (input)="onSearchByChange()"
                    />
                  </div>
                </div>


                <div *ngIf="!switchUserAccess">
                  <div class="position-relative search-container" >
                    <span
                      [inlineSVG]="'../../../media/icons/duotune/general/gen021.svg'"
                      class="
                        svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500
                        position-absolute
                        top-50
                        ms-1
                        translate-middle-y">
                      <svg style="margin-top:5px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                        </svg>
                    </span>
                    <input
                      type="text"
                      class="form-control search-input"
                      name="search"
                      [placeholder]="placeholderShow()"
                      [(ngModel)]="searchText"
                      (input)="onSearchChange()"
                    />
                  </div>
                </div>

                <!-- [inlineSVG]="'../../../assets/media/icons/duotune/general/gen021.svg'" -->
                <!-- <div class="position-relative search-container" >
                  <span
                    [inlineSVG]="'../../../media/icons/duotune/general/gen021.svg'"
                    class="
                      svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500
                      position-absolute
                      top-50
                      ms-1
                      translate-middle-y">
                    <svg style="margin-top:5px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                      <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                      </svg>
                  </span>
                  <input
                    type="text"
                    class="form-control search-input"
                    name="search"
                    placeholder="Search by Link,survey ID,PID"
                    [(ngModel)]="searchText"
                    (input)="onSearchChange()"
                  />
                </div> -->

                <div *ngIf="reportService.accessRoles.reports && reportService.accessRoles.reports.overall_report && reportService.accessRoles.reports.overall_report.download">
                  <button class="btn btn-sm fw-bold btn-blue download-btn"  (click)="download()">Download
                  </button>    
                </div>

                <!-- <div class="multiselect-dropdown-container">
                  <div class="selected-items"><span>{{getSelectedItems(12)}}</span></div>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Survey'"
                    [settings]="dropdownSettings"
                    [data]="dropdownSurveyList"
                    [(ngModel)]="selectedItems"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                  >
                  </ng-multiselect-dropdown>
                </div>
                <div class="multiselect-dropdown-container">
                  <div class="selected-items"><span>{{getSelectedStatusItems(10)}}</span></div>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Status'"
                    [settings]="dropdownStatusSettings"
                    [data]="dropdownStatusList"
                    [(ngModel)]="selectedStatusItems"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                  >
                  </ng-multiselect-dropdown>
                </div>
                <div data-kt-daterangepicker="true" data-kt-daterangepicker-opens="left" class="btn btn-sm fw-bold bg-body btn-color-gray-700 btn-active-color-primary d-flex align-items-center px-4">
                  <div [formGroup]="dateRangeForm" >
                    <ng2-flatpickr #endPicker [config]="dateRangeConfig" formControlName="dateRange"></ng2-flatpickr>
                  </div>
                </div>
                <div>
                  <button class="btn btn-sm fw-bold btn-white shadow" data-bs-toggle="modal" (click)="applyFilter()"><img src="../../../assets/media/icons/filter.png" class="filter-icon" alt=""/>Apply Filter</button>
                </div> -->

                <div class="filter-dropdown-container" *ngIf="reportService.accessRoles.reports && reportService.accessRoles.reports.overall_report && reportService.accessRoles.reports.overall_report.filter">
                  <div class="card-toolbar">
                    <button
                      type="button"
                      class="btn btn-sm fw-bold btn-white shadow"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                      data-kt-menu-flip="top-end"
                      data-kt-menu-static="true"
                    >
                      <img src="../../../assets/media/icons/filter.png" class="filter-icon" alt=""/>
                      <span class="filter-label"> Filter 

                        <span class="badge badge-danger badge-circle w-10px h-10px me-1" *ngIf="hasFilter"></span>
                      </span>
                    </button>
                    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3" data-kt-menu="true">
                      <div class="px-7 py-5 filter-heading">
                        <div class="fs-5 text-dark fw-bolder">Filter Options</div>
                        <div> <img data-kt-menu-dismiss="true" style="width: 12px; height: 12px; cursor: pointer;" src="../../../assets/media/icons/close_black.png" /></div>
                      </div>
                      <div class="separator border-gray-200"></div>
                      
                      <div class="filter-dropdown-div px-7 py-5">
                        <div class="mb-3" *ngIf="reportService.accessRoles.reports.overall_report.filter.survey">
                          <label class="form-label fw-bold">Survey:</label>
                          <div class="multiselect-dropdown-container">
                            <div class="selected-items"><span>{{getSelectedItems(15)}}</span></div>
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Survey'"
                              [settings]="dropdownSettings"
                              [data]="dropdownSurveyList"
                              [(ngModel)]="selectedItems"
                              (onSelect)="onItemSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                        </div>

                        <!-- <div class="mb-3" *ngIf="reportService.accessRoles.reports.overall_report.filter.client">
                          <label class="form-label fw-bold">Client:</label>
                          <div class="multiselect-dropdown-container ">
                            <div class="selected-items"><span>{{getSelectedItems(selectedClients,"name",20)}}</span></div>
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Client'"
                              [settings]="dropdownClientSettings"
                              [data]="dropdownClientList"
                              [(ngModel)]="selectedClients"
                              (onSelect)="onItemSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                        </div> -->


                        <div class="mt-3" *ngIf="reportService.accessRoles.reports.overall_report.filter.client">
                          <label class="form-label fw-bold">Client:</label>
                          <div class="multiselect-dropdown-container">
                            <select class="form-select text-muted fw-bold single-select" name="selectedClientUUID" [(ngModel)]="selectedClientUUID" >
                              <option value="" selected>Select Client</option>
                              <ng-container *ngFor="let client of dropdownClientList">
                                <option [value]="client.uuid">{{client.name}}</option>
                              </ng-container>
                             
                            </select>
                          </div>
                        </div>



                        <div class="mb-3" *ngIf="reportService.accessRoles.reports.overall_report.filter.response_status">
                          <label class="form-label fw-bold"> Response Status:</label>
                          <div class="multiselect-dropdown-container ">
                            <div class="selected-items"><span>{{getSelectedItems1(superUserResponseStatusItems,"value",18)}}</span></div>
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Status'"
                              [settings]="dropdownStatusSettings"
                              [data]="responseStatusList"
                              [(ngModel)]="superUserResponseStatusItems"
                              (onSelect)="onItemSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
  
                        <div class="mb-3" *ngIf="reportService.accessRoles.reports.overall_report.filter.payment_status">
                          <label class="form-label fw-bold">Payment Status:</label>
                          <div class="multiselect-dropdown-container ">
                            <div class="selected-items"><span>{{getSelectedItems1(superUserPaymentStatusItems,"value",18)}}</span></div>
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Status'"
                              [settings]="dropdownStatusSettings"
                              [data]="paymentStatusList"
                              [(ngModel)]="superUserPaymentStatusItems"
                              (onSelect)="onItemSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                        </div>

                      
                      
                        <div class="mb-3" *ngIf="dateResetDone && reportService.accessRoles.reports.overall_report.filter.date">
                          <div class="mb-0">
                            <label class="form-label fw-bold">Date Range:</label>
                            <div [formGroup]="dateRangeForm" >
                              <div class="mb-1">
                                <label class="form-label">From:</label>
                                <ng2-flatpickr #startPicker [config]="startOptions" formControlName="start"></ng2-flatpickr>
                              </div>
                              <div class="mb-1">
                                <label class="form-label">To:</label>
                                <ng2-flatpickr #endPicker [config]="endOptions" formControlName="end"></ng2-flatpickr>
                              </div>
                            </div>
                          </div>
                        </div>


                      
                      
                        <div class="d-flex justify-content-end">
                          <button
                            type="reset"
                            class="btn btn-sm btn-light btn-active-light-primary me-2"
                            data-kt-menu-dismiss="true"
                            (click)="resetFilter()"
                          >
                            Reset
                          </button>
                      
                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            data-kt-menu-dismiss="true"
                            (click)="applyFilter()"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
  
  
       
        <div class="py-5 main-container" *ngIf="isApiCallDone">
          <div class="table-responsive" *ngIf="reports && reports.length" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollPagination()">
           <table class="top_performers table table-row-dashed table-row-gray-300 gy-7">
            <thead class="t-header">
              <!-- Support Panel Table Header  --> 
              <div *ngIf="switchUserAccess">
                <tr  
                  [ngStyle]="{'display':'grid','grid-template-columns':SetGridColumns(),'grid-column-gap':'0px'}" 
                  class="fw-bold fs-6 text-gray-800 bg-white details-report-table-header-row">
                  <ng-container *ngFor="let Item of reportHeadersContainer">
                    <th class="table-th" [ngClass]="{'SurveyIdClass' : Item === 'Survey ID'}">
                      {{Item}}
                      <span *ngIf="Item == 'CPI'" class="rupee svg-icon-3 me-1">(&#8377;)</span>
                    </th>
                  </ng-container>
                </tr>
              </div>

              <!-- Normal Table Header  --> 
              <div *ngIf="!switchUserAccess">
                <!-- <tr  
                  class="fw-bold fs-6 text-gray-800 bg-white details-report-table-header-row">
                  <th class="table-th">Sl No.</th>
                  <th class="table-th">Survey Name (ID)</th>
                  <th class="table-th">Pid</th>
                  <th class="table-th">Start Time</th>
                  <th class="table-th">End Time</th>
                  <th class="table-th">Status</th>
                </tr> -->
                <tr class="fw-bold fs-6 text-gray-800 bg-white">
                  <th class="table-th">Sl No.</th>
                  <th class="table-th">Survey Name (ID)</th>
                  <th class="table-th">Pid</th>
                  <th class="table-th">Rid</th>
                  <th class="table-th" scope="col" [appSort]="reports" data-order="desc" data-name="full_start_time" data-type="date">Start Time
                    <span>
                      <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'full_start_time' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
                      <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'full_start_time' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
                    </span>
                  </th>
                  <th class="table-th" scope="col" [appSort]="reports" data-order="desc" data-name="full_end_time" data-type="date">End Time
                    <span>
                      <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'full_end_time' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
                      <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'full_end_time' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
                    </span>
                  </th>
                  <th class="table-th">Status</th>
                 </tr>
              </div>
          </thead>
          <tbody>
              <!-- Support Pannel  User Table  -->
              <div *ngIf="switchUserAccess">
                <tr class="bg-white"
                  [ngStyle]="{'display':'grid','grid-template-columns':SetGridColumns(),'grid-column-gap':'0px'}" 
                  *ngFor="let survey of reports; let i =index">
                  <td class="table-td fw-bold">{{i + 1}}</td>
                  <td class="table-td" data-toggle="tooltip" data-placement="bottom" [title]="survey.pid">
                    <div (click)="copyClipBoard('Pid',survey.pid)"  class="data-gap fw-bold">
                      {{formatSurveyrid(survey.pid) || 'NA'}}
                    </div>
                  </td>
                  <td class="table-td" data-toggle="tooltip" data-placement="bottom" [title]="survey.rid" >
                    <div (click)="copyClipBoard('Rid',survey.rid)"  class="data-gap fw-bold">
                      {{formatSurveyrid(survey.rid) || "NA"}}
                    </div>
                  </td>
                  <td class="table-td ms-2" data-toggle="tooltip" data-placement="bottom" [title]="survey.survey_id">
                    <a *ngIf="clientSelectedUser || defaultSelectedUser" 
                    class="fw-bold text-primary data-gap" 
                    (click)="redirectPageSurveyDetails(survey)" 
                    style="text-decoration: underline; cursor: pointer;"
                    [href] = "CreateRedirectLink(survey.survey_id)"
                    target="_blank"
                    >
                      {{survey.survey_name || "-"}}
                    </a>
                  </td>
                  <td class="table-td fw-bold">{{survey.client_name || "NA"}}</td>
                  <td class="table-td fw-bold">{{survey.cpi || "-"}}</td>
                  <td class="table-td fw-bold">{{survey.loi || "NA"}}</td>
                  <td *ngIf="clientSelectedUser || defaultSelectedUser" class="table-td fw-bold">
                    <a *ngIf="survey.response_status"
                      class="fw-bold"
                      (click)="responseStatusModalOpen(survey.rid)" 
                      style="text-decoration: underline; cursor: pointer;">{{survey.response_status || "-"}}
                    </a>
                    <div *ngIf="!survey.response_status" class="fs-6">{{"NA"}}</div>
                  </td>
                  <td *ngIf="clientSelectedUser || defaultSelectedUser" class="table-td" [ngStyle]="{'color':survey.payment_color}">
                    <a *ngIf="survey.payment_status"
                      class="fw-bold"
                      (click)="paymentStatusModalOpen(survey.rid)" 
                      style="text-decoration: underline; cursor: pointer;" >
                      {{survey.payment_status || "-"}}
                      <i class="fa fa-info-circle info-tag cursor-pointer" aria-hidden="true" *ngIf="survey.payment_status == 'Settlement Pending'" data-bs-toggle="tooltip" data-bs-custom-class="tooltip-inverse" [title]="survey.settlement_pending_reason"></i>
                    </a>
                    <div *ngIf="!survey.payment_status" class="fw-bold">{{"NA"}}</div>
                  </td>
                  <!-- <td *ngIf="defaultSelectedUser" class="table-td fw-bold">{{survey.response_status || "-"}}</td> -->
                  <!-- <td *ngIf="defaultSelectedUser" class="table-td fw-bold">{{survey.payment_status || "-"}}</td> -->
                  <td class="table-td fw-bold">
                    <a *ngIf="survey.cags" 
                      style="text-decoration: underline; cursor: pointer;" 
                      class="text-primary"
                      (click)="CagsDeatailsModalOpen(survey.cags)"
                    >
                      View
                    </a>
                    <div *ngIf="!survey.cags">
                      -
                    </div>
                  </td>
                  <td class="table-td fw-bold" [title]="survey.start_time">{{survey.start_time || "-"}}</td>
                  <td class="table-td fw-bold" [title]="survey.end_time">{{survey.end_time || "-"}}</td>
                </tr>
              </div>


              <!-- Normal User Table  -->
              <div *ngIf="!switchUserAccess">
                <tr class="bg-white"
                  *ngFor="let survey of reports; let i =index">
                  <td class="table-td">{{i + 1}}</td>

                  <td class="table-td">{{survey.survey_name || "-"}}<p class="text-sm-10">({{survey.survey_id || "-"}})</p></td>
                  <td class="table-td"><div class="pid">{{survey.pid || "-"}}</div></td>
                  <td class="table-td"><div class="pid">{{survey.rid || "-"}}</div></td>
                  <td class="table-td">{{survey.start_time || "-"}}</td>
                  <td class="table-td">{{survey.end_time || "-"}}</td>
               
                  <td class="table-td">
                    <div [ngStyle]="{'color':survey.color}" style="padding: 0px 5px;">{{survey.status || "-"}}</div>
                    <div [ngStyle]="{'color':survey.color}" *ngIf="(survey.status == 'Rejected')" class="text-sm-10 cursor-pointer" data-bs-toggle="tooltip" data-bs-custom-class="tooltip-inverse" [title]="survey.rejection_comment">
                      <span class="rejected" *ngIf="survey.rejection_reason && survey.rejection_reason !='NA'">{{survey.rejection_reason}}</span>
                    </div>
                  </td>
                  <!-- <td class="table-td"><div [className]="survey.status | lowercase ">{{survey.status || "-"}}</div></td> -->
                </tr>
              </div>
            </tbody>
           </table>
          </div>
          <div class="null-table-container card shado-effect" *ngIf="!(reports && reports.length)">
              <img class="blank-survay-list" src="../../../assets/media/survey/blank_survay_list1.png" alt="" />
              <div class="null-table-text">No records available for the applied filter</div>
          </div>
        </div>
  </div>